import { Button, Chip, Grid, Icon, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AccountSubscriptionType } from "../../../api/psc";
import {
    SubscriptionPageInfoType,
    SubscriptionPricingPeriods,
} from "../../../constants/SubscriptionConstants";
import { RootState } from "../../../slices/Store";
import { setViewInSubscriptionMode } from "../../projects/slice/ProjectSlice";

export default function SubscriptionItem(props: SubscriptionPageInfoType) {
    const shared = useSelector((state: RootState) => state.shared);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const accountSubscriptionType = shared.accountDetail.subscriptionType;

    function handleNavigateToSubscription(type: AccountSubscriptionType[]) {
        dispatch(setViewInSubscriptionMode(type));
        navigate("/");
    }

    const minHeight = { md: "200px", lg: "400px", xl: "300px" };

    return (
        <Grid item xs={12} md={6} lg={3}>
            <Stack
                direction="column"
                alignItems="center"
                spacing={4}
                sx={{
                    width: "100%",
                    height: "100%",
                    border: "1px solid",
                    borderColor: "divider",
                    backgroundColor: "background.paper",
                    p: 4,
                    borderRadius: "12px",
                }}
            >
                <img
                    alt={props.title}
                    width={75}
                    height={75}
                    src={props.imageUrl}
                />

                <Stack
                    direction="row"
                    justifyContent="center"
                    gap={2}
                    sx={{
                        bgcolor: props.titleColor,
                        py: 1,
                        borderRadius: "12px",
                        width: "200px",
                        textAlign: "center",
                    }}
                >
                    <Typography sx={{ fontSize: "20px" }} color="white">
                        {props.title}
                    </Typography>

                    {accountSubscriptionType === props.type && (
                        <Chip color="secondary" label="اشتراک شما" />
                    )}
                </Stack>

                <Stack
                    component="section"
                    aria-label={`قیمت اشتراک ${props.title}`}
                    spacing={1.5}
                    sx={{ width: "100%" }}
                >
                    <Typography fontWeight={700} textAlign="center">
                        قیمت اشتراک
                    </Typography>
                    {SubscriptionPricingPeriods.map(({ months, label }) => (
                        <Stack
                            key={months}
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            useFlexGap
                            flexWrap="wrap"
                            gap={1}
                        >
                            <Typography color="text.secondary">
                                {label}
                            </Typography>
                            <Typography
                                color="primary"
                                fontWeight={700}
                                sx={{ whiteSpace: "nowrap" }}
                            >
                                {props.pricesInToman[months].toLocaleString("fa-IR")}
                            </Typography>
                        </Stack>
                    ))}
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        textAlign="center"
                    >
                        مبلغ کل هر دوره به تومان؛ قیمت ماهانه نیست.
                    </Typography>
                </Stack>

                <Stack direction="column" gap={1} alignItems="center">
                    <Typography color="primary">
                        تعداد تقریبی پروژه‌‌ها:
                    </Typography>
                    <Chip
                        size="small"
                        color="primary"
                        label={props.totalProjectCount}
                    ></Chip>
                </Stack>

                <Stack direction="row" gap={1} alignItems="center">
                    <Typography color="primary">
                        پروژه‌های خاص این اشتراک:
                    </Typography>
                    <Chip
                        size="small"
                        color={
                            props.exclusiveProjectCount === "ندارد"
                                ? "error"
                                : "secondary"
                        }
                        label={props.exclusiveProjectCount}
                    ></Chip>
                    {/*<Typography>*/}
                    {/*    تا انتهای تیر ماه ۱۴۰۴*/}
                    {/*</Typography>*/}
                </Stack>

                <Typography color="secondary">{props.definition}</Typography>

                <Typography
                    color="text.secondary"
                    sx={{
                        minHeight: minHeight,
                        textAlign: "justify",
                    }}
                >
                    {props.description}
                </Typography>

                <Stack gap={2}>
                    {props.properties.map((p, i) => (
                        <Stack direction="row" gap={1}>
                            <Icon
                                color={
                                    p.icon === "close" ? "error" : "secondary"
                                }
                            >
                                {p.icon}
                            </Icon>
                            {p.text}
                        </Stack>
                    ))}
                </Stack>

                <span style={{ flex: 1 }}></span>

                <Button
                    fullWidth={true}
                    variant="contained"
                    onClick={() =>
                        handleNavigateToSubscription(
                            props.subscriptionForNavigation
                        )
                    }
                >
                    مشاهده پروژه های این نوع اشتراک
                </Button>
            </Stack>
        </Grid>
    );
}
